import React,{ useState, useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getSpecificPortalSubmissions } from '../../api/axiosPortalSubmissions';
import ProcessDiscard from '../../components/buttonActions/ProcessDiscard';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { Tag } from 'primereact/tag';     
import { useNavigate } from 'react-router-dom';
import useWindowSize from '../../hooks/useWindowSize';
import { useContext } from 'react';
import DataContext from '../../context/DataContext';
import { Skeleton } from 'primereact/skeleton';
import { Paginator } from 'primereact/paginator';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import { Dialog } from 'primereact/dialog';
import IncidentViewForm from '../../components/incident/IncidentViewForm';
import { getSpecificIncidents } from '../../api/axiosIncidents';





const IncidentsTable = ({incidentTitle, incidentValidity}) => {
 
  const { setFetcherror,auntheticatedUser} = useContext(DataContext);
 

  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [viewDialogVisible, setViewDialogVisible] = useState(false);
  const [incidents, setIncidents] = useState([]);
  const [ICNrowData, setICNrowData] = useState({});




  const user_id = auntheticatedUser?.id;

  const monitorinitiated =  (auntheticatedUser?.role === "Admin" || auntheticatedUser?.role === "Operator" || auntheticatedUser?.role === "LHRCstaff") ? false:true 
  

  useEffect(() => {

    fetchIncidents();   
  }, []);



  const fetchIncidents = (eventx) => { 
    if (monitorinitiated) {
        
      if (incidentValidity) {
        getSpecificIncidents(
          setIncidents,
          setFetcherror,
          setIsLoading,
          setFirst,
          setRows,
          eventx,
          setTotalCount,
          true,
          false,
          true,
          user_id
        )
      };
      if (!incidentValidity) {
        getSpecificIncidents(
          setIncidents,
          setFetcherror,
          setIsLoading,
          setFirst,
          setRows,
          eventx,
          setTotalCount,
          true,
          false,
          false,
          user_id
        )
      }
    } else { 

      if (incidentValidity) {
        getSpecificIncidents(
          setIncidents,
          setFetcherror,
          setIsLoading,
          setFirst,
          setRows,
          eventx,
          setTotalCount,
          true,
          false,
          true
        )
      };
      if (!incidentValidity) {
        getSpecificIncidents(
          setIncidents,
          setFetcherror,
          setIsLoading,
          setFirst,
          setRows,
          eventx,
          setTotalCount,
          true,
          false,
          false
        )
      }


    }
  }

  // const incidentTitle = <span className='p-5'>New Incident</span>;
  // const finalrolesArray = roles.map((role) => ({ ...role, name: (role?.name).substring(2) })).filter((item) => item?.name !== "Admin");
  


 
  
  const filteredPortalSubmissions = incidents.length>0 ?  incidents?.filter( (item) => item.eventdescription.toLowerCase().includes(globalFilter)) : []
  // const filteredReversedPortalSubmissions = filteredPortalSubmissions.reverse();



  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  const extractTime = (timestamp) => { 
    const stamp = new Date(timestamp);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const dateTime = `${stamp.getDate()} ${months[stamp.getMonth()]} ${stamp.getFullYear()}  ${stamp.getHours()}:${stamp.getMinutes()}`;
    return dateTime;
  }

  const toProperCase = (textValue) => { 
    const newtextValue = textValue[0].toUpperCase() + textValue.substring(1).toLowerCase();
    return newtextValue;
  }

  const onPageChange = (event) => {
    fetchIncidents(event);
  }
    
  
  const limitOptions = [5, 10, 20, 30, 50];
  const skeletonitems = Array.from({ length: 5 }, (v, i) => i);
  const maincardtitle = <div className='text-center'>{incidentTitle }</div>;
  
  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={maincardtitle}>
      <SearchToolBar
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                searchPlaceholder="Incidents"
        
        />
        
        {!isLoading &&
          <DataTable
            value={filteredPortalSubmissions}
            showGridlines
            emptyMessage="No Incidents found"
            className=''
          >
            <Column className='w-5rem' header="S/N" body={(rowData) => incidents?.indexOf(rowData) + 1} > </Column>
            <Column
              className='w-18rem'
              header="Victim Details"
              body={(rowData) => (
                <div className='flex flex-column'>
                  <div className='text-color-secondary font-bold mb-2'>{rowData?.incidentnumber}</div>
                  <div className='text-color-secondary text-sm font-bold'>Name:{rowData?.firstnamevictim} {rowData?.lastnamevictim}</div>
                  <div className='text-color-secondary text-sm'>Phone:{rowData?.phonevictim}</div>
                  <div className='text-color-secondary text-sm'>Sex:{rowData?.sexvictim}</div>
                </div>

              )} >
            
            </Column>
                    
            <Column
              className=''
              header="Description"
              sortable
              body={(rowData) => (rowData.eventdescription)}>
            </Column>
          
            <Column
              className='w-12rem'
              header="Location & Status"
              body={(rowData) => (
                <div className='flex flex-column'>
                  <div className='text-color-secondary font-bold'>{rowData?.region}</div>
                  <div className='text-color-secondary'>{toProperCase(rowData?.district)}</div>
                  <div className='text-color-secondary'>{toProperCase(rowData?.ward)}</div>
                  <div className='mt-2 text-xs' ><span><Tag severity="success" value="Processed"></Tag></span> <span><Tag severity={incidentValidity?"success":"danger"} value={incidentValidity?"Valid":"Invalid"}></Tag></span></div>
                  <div className='mt-2 text-sm'>{extractTime(rowData?.createdAt)}</div>
                </div>
              )}>
            </Column>
          
          
            <Column
              className='w-8rem'
              header="Actions"
              body={(rowData) => (
                <Button
                    outlined
                    label="View"
                    icon="pi pi-eye"
                    className=" p-button-success px-3 py-1 text-xs mb-2 font-light"
                    onClick={() => {
                        
                      setViewDialogVisible(true);
                      setICNrowData(rowData);
                }}
                />
              )}>
            </Column>
          </DataTable>
        }
        
        {isLoading && 
          
          <DataTable value={skeletonitems} className="p-datatable-striped">
          <Column field="S/N" header="S/N" style={{ width: '10%' }} body={<Skeleton />}sortable></Column>
          <Column field="Reporter Details" header="Reporter Details" style={{ width: '15%' }} body={<Skeleton />}sortable></Column>
          <Column field="Description" header="Description" style={{ width: '50%' }} body={<Skeleton />}sortable></Column>
          <Column field="Location & Status" header="Location & Status" style={{ width: '15%' }} body={<Skeleton />}></Column>
          <Column field="Actions" header="Actions" style={{ width: '10%' }} body={<Skeleton />}></Column>
          </DataTable>
          }

          {!isLoading &&
            <Paginator
              first={first}
              rows={rows}
              totalRecords={totalCount}
              rowsPerPageOptions={limitOptions}
              onPageChange={onPageChange}
            />
          } 
        
        

        <Dialog visible={viewDialogVisible} modal  headerClassName='mb-0 pb-0' style={{ width: '80rem' }} onHide={() => setViewDialogVisible(false)}>
          <IncidentViewForm
            setFetcherror={setFetcherror}
            viewDialogVisible={viewDialogVisible} setViewDialogVisible={setViewDialogVisible}
            ICNrowData={ICNrowData}
           
            incidentValidity={incidentValidity}
            monitorinitiated={monitorinitiated}
            handleAllToasts={handleAllToasts}
            fetchIncidents={fetchIncidents }
            
              />

               
        </Dialog>


                
      </Card>

   
    </div>
  )
}

export default IncidentsTable